import { useEffect, useState } from 'react'
import back_app from './back_app'



export const CAT_LBLS: Record<string, string> = {
  arts_entertainment: 'Arts & Entertainment',
  automotive: 'Automotive',
  beauty_personal_care: 'Beauty & Personal Care',
  business_professional_services: 'Business & Professional Services',
  clothing_fashion: 'Clothing & Fashion',
  consumer_goods: 'Consumer Goods',
  consumer_electronics: 'Consumer Electronics',
  construction_home_improvement: 'Construction & Home Improvement',
  digital_products_software: 'Digital Products & Software',
  education: 'Education',
  energy_utilities: 'Energy & Utilities',
  events_experiences: 'Events & Experiences',
  finance_insurance: 'Finance & Insurance',
  food_beverage: 'Food & Beverage',
  fitness_sports: 'Fitness & Sports',
  gaming: 'Gaming',
  health_wellness: 'Health & Wellness',
  home_living: 'Home & Living',
  industrial_manufacturing: 'Industrial & Manufacturing',
  luxury_goods: 'Luxury Goods',
  media_publishing: 'Media & Publishing',
  non_profit_social_impact: 'Non-Profit & Social Impact',
  real_estate: 'Real Estate',
  retail_ecommerce: 'Retail & E-Commerce',
  technology_telecommunications: 'Technology & Telecommunications',
  travel_hospitality: 'Travel & Hospitality',
}

export const cat_id2lbl = (id: string | null | undefined): string =>
  (id && CAT_LBLS[id]) || id || ''

let _ids_promise: Promise<string[]> | null = null
let ids_load = (): Promise<string[]> => {
  if (_ids_promise)
    return _ids_promise
  _ids_promise = (async () => {
    let res = await back_app.camp_cat_get()
    if (res?.err || !Array.isArray(res?.list))
      return Object.keys(CAT_LBLS)
    return res.list as string[]
  })()
  return _ids_promise
}

export const useCatIds = () => {
  let [ids, set_ids] = useState<string[]>([])
  let [loading, set_loading] = useState(true)
  useEffect(() => {
    let cancelled = false
    ids_load().then(list => {
      if (cancelled)
        return
      set_ids(list)
      set_loading(false)
    })
    return () => { cancelled = true }
  }, [])
  return { ids, loading }
}